import { ENV_VARS } from "../config/config";

const logOutUser = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("randomCode");
  window.location.replace(ENV_VARS.REDIRECT_URI);
};

export default logOutUser;
